import { getTestIds } from 'seagull/utils/TestIds';
import { associatedCustomersOf } from '../ContactsDashboardRow.utils';
export const addContactToClientModalTextsPath = 'pages.contactsDashboard.addToClientModal';
export const CLIENT_FIELD_NAME = 'customerId';
export const ROLE_FIELD_NAME = 'role';
export const associableClientsFor = (contact, clients)=>{
    const associatedIds = new Set(associatedCustomersOf(contact).map((customer)=>customer.customerId));
    return clients.filter((client)=>client.status() === 'active').filter((client)=>!client.isSample() && !associatedIds.has(client.clientId())).map((client)=>({
            clientId: client.clientId(),
            name: client.name()
        })).sort((first, second)=>first.name.localeCompare(second.name));
};
export const GetAddContactToClientModalTID = (parentTestId)=>getTestIds(parentTestId);
